<template>
    <b-container id="softfair_offers" class="mt-8 pb-5">
        <!-- h1>OFFERS LIST</h1 -->
        <b-row class="justify-content-center">
            <b-col lg="10">
                <b-card-group class="pricing flex-column flex-md-row mb-3">

                    <div v-for="elem in offer.pricing" :key="elem.id">
                        <h1>{{ elem.title }}</h1>
                        dadasdasdasd
                        <softfair-offers-list-element :offer="elem" />

                    </div>

                </b-card-group>
            </b-col>
        </b-row>

    </b-container>

</template>

<script>
import { mapGetters, mapState } from "vuex";
import SoftFairOffersListElement from "./SoftFairOffersListElement.vue";

export default {
    name: "softfair-offers-list",
    props: {
        offers: {
            type: Object,
        },
    },
    components: {
        SoftFairOffersListElement,
    },
    data() {
        return {
            loading: false,
            showUsage: false,
        };
    },
    methods: {
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
        }),
        ...mapState({
            account: state => state.account,
            offer: state => state.softfairOffer,
            pricing: state => state.softfairOffer.pricing,
        })
    },
    watch: {
        offer: {
            handler: function (newItem, newValue) {
                console.log("offer changed within offers-list");
                console.log(newItem);
                console.log(newValue);
            },
            deep: true
        },
        pricing: {
            handler: function (newItem, newValue) {
                console.log("pricing changed within offers-list");
                console.log(newItem);
                console.log(newValue);
            },
            deep: true
        },
    },
    mounted() {
        console.log("THE offers within offers-list");
        console.log(this.offer);
        console.log("THE offers within offers-list");
    },
};
</script>
<style></style>